import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IBaseHistoryParameter } from "../../../models/base-history-paramter";
import TimeLinePopoverComponent from "../timeline-popover";
import { DataHelper } from "../../../utils/data-helper";
import { LabelSetting } from "../../../i18n/locale-helper";
import moduleConstant from "../../../common/module-constant";

import { namespace, Action, Getter, Mutation } from "vuex-class";
import { storeModules } from "../../../store";
import lookupTypesStore from '../../../store/lookup/lookup-types.store';
import { IBasePositiveAndNegative } from "../../../models/common/AgendaCommon";
import { orderBy } from '../../../utils/util';
import UnitConstants from "../../../common/unit-constant";
import EditProspectComponent from "./edit-prospect-modal/EditProspectComponent.vue";
import { PropertyHistoryProspectModel } from "../../../models/history";
import EventBus from "../../../utils/event-bus";
import { EVENT_BUS } from "../../../common/constants";
import { DrawerModel, IDrawerModel } from "../../../models/common/drawer.model";
import { DRAWER_NAME } from "../../../common/drawer-component.constants";

const LookupAction = namespace(storeModules.Lookup, Action);
const LookupGetter = namespace(storeModules.Lookup, Getter);
const CommonMutation = namespace(storeModules.Common, Mutation);
@Component({
  template: require("./template.html"),
  components: {
    "timeline-popover": TimeLinePopoverComponent,
    "edit-modal": EditProspectComponent,
  }
})
class PropspectsComponent extends Vue {
    @Prop() data: any[];

    @Prop() originData: any;

    @Prop() searchData: IBaseHistoryParameter;

    @Prop()
    isLoading: boolean; 

    @Prop({default: null})
    scrollbarOffset: number;

    @Prop() module: number;

    @Prop({ default: "Date", type: [String] })
    datetimeKey: string;
    
    UnitConstants = UnitConstants;
    currentRow: PropertyHistoryProspectModel = null;

    @LookupAction private getLookupData: (type: string) => void;
    @LookupGetter listOfNegativeComments: IBasePositiveAndNegative[];
    @CommonMutation setVisibleDrawerModel: (payload: IDrawerModel) => void;

  
    get fieldName() { return "Name" + this.$i18n.locale.substring(0, 2).toLocaleUpperCase() }
    
    get lblAgenda() {
        return LabelSetting.Agenda;
    }

    get lblSetting() {
        return LabelSetting.Property;
    }

    get lblGlobal() {
        return LabelSetting.Global;
    }

    get tableData() {
        return this.data.map((t) => {
            let clone = DataHelper.deepClone(t);
            clone["timelineVisible"] = false;
            return clone;
        });
    }

    get isProjectModule(): Boolean {
        return this.module == moduleConstant.Project;
    }

    get coListOfNegative() {
        let getList = this.listOfNegativeComments || []
        return orderBy(getList, this.fieldName, 1)
    }

    openPersonDetail(row) {
        console.log("openPersonDetail", row);
        this.setVisibleDrawerModel(new DrawerModel({
            componentName: DRAWER_NAME.PERSON_DETAIL,
            props: {
                objectId: row.PersonId
            },
            title: 'PERSONS'
        }));
    }

    openPopover(row) {
        console.log("openPopover", row);

        this.setVisibleDrawerModel(new DrawerModel({
            componentName: DRAWER_NAME.HISTORY_TIMELINE_POPOVER,
            props: {
                data: row,
                datetimeKey: this.datetimeKey,
                dataPropKey: "listOfPropertyPropertyProspectHistory",
                index: this.getIndex(row),
                searchData: this.searchData,
                scrollbarOffset: 10,
            },
            title: row.Name,
            showSaveBtn: false
        }))
    }

    getIndex(row) {
        return this.tableData.indexOf(row);
    }

    getCoInfo (row) {
        if (row && row.NoInterestReasonInfo) {
            const vm = this as any;
            return vm.$td(row.NoInterestReasonInfo, 'Name');
        }
        return "";
    }

    refreshHistoryProspect () {
        EventBus.$emit(EVENT_BUS.HISTORY.UPDATE_HISTORY_LIST);
    }

    openEditPopup (row: any) {
        this.currentRow = new PropertyHistoryProspectModel(row);
    }

    async created() {
        this.getLookupData(lookupTypesStore.Get.NEGATIVE_COMMENTS);
    }
}

export default PropspectsComponent;
